import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-containers',
  imports: [CommonModule, RouterLink],
  templateUrl: './containers.html',
  styleUrl: './containers.css'
})
export class Containers {
  features = [
    {
      title: 'Docker Containerization',
      description: 'Containerize applications with Docker for consistent deployment across any environment.',
      icon: 'docker'
    },
    {
      title: 'Kubernetes Orchestration',
      description: 'Deploy and manage containers at scale with Kubernetes on EKS, AKS, GKE, or self-managed clusters.',
      icon: 'kubernetes'
    },
    {
      title: 'Helm Chart Management',
      description: 'Package and deploy applications with Helm charts for simplified Kubernetes deployments.',
      icon: 'helm'
    },
    {
      title: 'Service Mesh Integration',
      description: 'Implement Istio or Linkerd for advanced traffic management, security, and observability.',
      icon: 'mesh'
    },
    {
      title: 'Container Registry Management',
      description: 'Secure container image storage and distribution with ECR, ACR, GCR, or private registries.',
      icon: 'registry'
    },
    {
      title: 'Auto-Scaling & High Availability',
      description: 'Horizontal pod autoscaling and cluster autoscaling for optimal resource utilization.',
      icon: 'scaling'
    }
  ];

  process = [
    { step: 1, title: 'Containerization Assessment', description: 'Evaluate applications for containerization and identify migration strategy.' },
    { step: 2, title: 'Container & Cluster Design', description: 'Design container architecture and Kubernetes cluster configuration.' },
    { step: 3, title: 'Migration & Deployment', description: 'Containerize applications and deploy to Kubernetes with CI/CD integration.' },
    { step: 4, title: 'Optimize & Monitor', description: 'Fine-tune resource allocation and implement comprehensive monitoring.' }
  ];

  caseStudy = {
    client: 'TechScale Platforms',
    industry: 'SaaS Technology',
    image: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?w=800&h=500&fit=crop',
    challenge: 'TechScale ran monolithic applications on expensive EC2 instances with poor resource utilization and long deployment times. Scaling was manual and often caused service disruptions.',
    solution: 'We containerized their applications with Docker, migrated to Amazon EKS with Kubernetes orchestration, and implemented automated scaling based on demand.',
    results: [
      { metric: '70%', description: 'Reduction in Infrastructure Costs' },
      { metric: '92%', description: 'Improvement in Resource Utilization' },
      { metric: '15min', description: 'Deployment Time (from 2 hours)' },
      { metric: 'Auto', description: 'Scaling Based on Traffic' }
    ]
  };

  testimonial = {
    quote: 'Kubernetes seemed intimidating at first, but HoneyKode made the migration seamless. Our infrastructure costs dropped by 70%, deployments are 8x faster, and we can now handle traffic spikes automatically. The ROI was incredible.',
    author: 'Rachel Martinez',
    role: 'VP of Engineering',
    company: 'TechScale Platforms',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  };

  tools = [
    { name: 'Docker', category: 'Containerization' },
    { name: 'Kubernetes', category: 'Orchestration' },
    { name: 'Amazon EKS', category: 'Managed K8s' },
    { name: 'Azure AKS', category: 'Managed K8s' },
    { name: 'Google GKE', category: 'Managed K8s' },
    { name: 'Helm', category: 'Package Manager' },
    { name: 'Istio', category: 'Service Mesh' },
    { name: 'ArgoCD', category: 'GitOps' }
  ];
}
